import { requestSubscription, graphql } from "react-relay";
import { ConnectionHandler } from "relay-runtime";
import environment from "../Network";

const subscription = graphql`
  subscription TimetableSubscription {
    timetableSubscription {
      action
      dayPresencesIncidentalOld
      timetable {
        id
        pk
        year
        weekOfYear
        status
        dayPresences
        dayPresencesIncidental
        employee {
          id
          pk
          displayName
        }
      }
    }
  }
`;

export default (variables) => {
  return requestSubscription(
    environment, // see Environment docs
    {
      subscription,
      variables: variables ? variables : {},
      updater: (store) => {
        // Get the notification
        const rootField = store.getRootField("timetableSubscription");
        const timetable = rootField.getLinkedRecord("timetable");
        const action = rootField.getValue("action");
        // Add it to a connection
        let viewer = store.getRoot().getLinkedRecord("user");
        const userId = viewer.getValue("id");
        const timetableUserId = timetable
          .getLinkedRecord("employee")
          .getValue("id");
        const timetableNode = store.get(timetable.getValue("id"));
        const oldChanged = rootField.getValue("dayPresencesIncidentalOld");
        if (userId === timetableUserId && action === "update" && viewer) {
          if (timetableNode) {
            timetableNode.setValue(
              timetable.getValue("dayPresences"),
              "dayPresences"
            );
            timetableNode.setValue(
              timetable.getValue("dayPresencesIncidental"),
              "dayPresencesIncidental"
            );
          }
        }
        viewer = store.getRoot().getLinkedRecord("adminDashboard");
        if (viewer) {
          const changed = !!timetable.getValue("dayPresencesIncidental");
          let connection = null;
          if (action === "created") {
            if (changed) {
              connection = ConnectionHandler.getConnection(
                viewer,
                "ChangedSchedulesTab_changedSchedules"
              );
              const timetableEdge = ConnectionHandler.createEdge(
                store,
                connection,
                timetable,
                "TimetableType"
              );
              ConnectionHandler.insertEdgeAfter(connection, timetableEdge);
            } else {
              connection = ConnectionHandler.getConnection(
                viewer,
                "AcceptedSchedulesTab_acceptedSchedules"
              );
              const timetableEdge = ConnectionHandler.createEdge(
                store,
                connection,
                timetable,
                "TimetableType"
              );
              ConnectionHandler.insertEdgeAfter(connection, timetableEdge);
            }
          } else {
            if (oldChanged !== changed) {
              if (oldChanged) {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "ChangedSchedulesTab_changedSchedules"
                );
              } else {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "AcceptedSchedulesTab_acceptedSchedules"
                );
              }
              ConnectionHandler.deleteNode(
                connection,
                timetable.getValue("id")
              );
              if (changed) {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "ChangedSchedulesTab_changedSchedules"
                );
              } else {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "AcceptedSchedulesTab_acceptedSchedules"
                );
              }
              const timetableEdge = ConnectionHandler.createEdge(
                store,
                connection,
                timetable,
                "TimetableType"
              );
              ConnectionHandler.insertEdgeAfter(connection, timetableEdge);
            }
          }
        }
      },
      // optional but recommended:
      onCompleted: () => {
        /* server closed the subscription */
      },
      onError: (error) => console.error(error),
    }
  );
};



// WEBPACK FOOTER //
// ./src/subscriptions/TimetableSubscription.js